import { Plugin } from '@ckeditor/ckeditor5-core';
import { createDropdown, addListToDropdown, Model, SplitButtonView } from '@ckeditor/ckeditor5-ui';
import { Collection } from '@ckeditor/ckeditor5-utils';
import recordIcon from '../ckeditor5-recorder/theme/icons/recordvideo.svg';
import videoIcon from '../ckeditor5-toolbar-custom/theme/icons/videoIcon.svg';
import uploadIcon from '../ckeditor5-video/theme/icons/video.svg';

export default class VideoMenu extends Plugin {
	init() {
		const editor = this.editor;

		editor.ui.componentFactory.add('videoMenu', locale => {
			// Crear el dropdown con SplitButton
			const dropdownView = createDropdown(locale, SplitButtonView);

			// Configurar el botón principal
			const actionView = dropdownView.buttonView.actionView;
			actionView.set({
				label: 'Insertar video',
				icon: videoIcon,
				tooltip: 'Insertar video'
			});

			// Acción principal → subir video
			actionView.on('execute', () => {
				// Abre el diálogo de selección de archivos local
				const input = document.createElement('input');
				input.type = 'file';
				input.accept = 'video/*';
				input.multiple = false;

				input.addEventListener('change', () => {
					if (input.files && input.files.length > 0) {
						const file = input.files[0];
						if (file instanceof Blob) {
							editor.execute('videoUpload', { files: [file] });
						} else {
							console.error('Archivo inválido o no es un Blob:', file);
						}
					}
				});

				input.click();
			});

			// Submenú: subir o grabar video
			const items = [
				{ command: 'videoUpload', label: 'Subir video', icon: uploadIcon },
				{ command: 'recordVideo', label: 'Grabar video', icon: recordIcon }
			];

			const itemDefinitions = new Collection();
			for (const item of items) {
				const model = new Model({
					command: item.command,
					label: item.label,
					withText: true,
					icon: item.icon
				});
				itemDefinitions.add({ type: 'button', model });
			}

			addListToDropdown(dropdownView, itemDefinitions);

			// Ejecutar comando al seleccionar una opción del submenú
			this.listenTo(dropdownView, 'execute', evt => {
				const commandName = evt.source.command;
				if (!commandName) return;

				if (commandName === 'recordVideo') {
					editor.execute('recordVideo');
				} else if (commandName === 'videoUpload') {
					const input = document.createElement('input');
					input.type = 'file';
					input.accept = 'video/*';
					input.multiple = false;

					input.addEventListener('change', () => {
						if (input.files && input.files.length > 0) {
							const file = input.files[0];
							if (file instanceof Blob) {
								editor.execute('videoUpload', { files: [file] });
							}
						}
					});

					input.click();
				}

				editor.editing.view.focus();
			});

			// Estilo visual igual al botón de imagen
			dropdownView.extendTemplate({
				attributes: {
					class: ['ck-splitbutton', 'ck-video-splitbutton']
				}
			});

			return dropdownView;
		});
	}
}
